import { postRequest } from "../shared/utils";

export async function getChildTableDetailsService(screenGridId, screenId, configSchema) {
  const body = {
    columns: ['id', 'mbdDatagrid: mbd_data_grid{dataGridInternalName: data_grid_internal_name}'],
    screenGridId,
    schema: configSchema,
    table: 'mbd_screen_to_data_grids',
    key: 'screen_id',
    value: screenId,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
